import { map } from "rxjs";
import apiService from "../ApiService";

export const ubisoftAuthorize = (gameID?: string) => {
  return apiService
    .get<{ url: string }>({
      path: "v1/store/ubisoft/auth/authorize",
      params: {
        gameID,
      },
    })
    .pipe(map((e) => e.url));
};
